import React, { createContext, useState, useCallback } from 'react';

/**
 * SidebarContext provides the expanded/collapsed state of the sidebar
 * to all child components so they can adjust their layout accordingly
 */
export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false); // Default: collapsed
  const [isSidebarHoverExpanded, setIsSidebarHoverExpanded] = useState(false);

  const updateSidebarState = useCallback((expanded, hoverExpanded = false) => {
    setIsSidebarExpanded(expanded);
    setIsSidebarHoverExpanded(hoverExpanded);
  }, []);

  const value = {
    isSidebarExpanded,
    isSidebarHoverExpanded,
    isAnySidebarStateExpanded: isSidebarExpanded || isSidebarHoverExpanded,
    updateSidebarState,
    // Calculate sidebar width based on state
    sidebarWidth: isSidebarExpanded || isSidebarHoverExpanded ? 280 : 72,
  };

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebarContext = () => {
  const context = React.useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebarContext must be used within SidebarProvider');
  }
  return context;
};
